<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">

  <!-- ===== Header ===== -->
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-6 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">แจกสิทธิ์โควต้าจอดฟรี</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        แบ่งโควต้าลานให้ Client / ผู้เช่าใช้ออกบัตรจอดฟรี
        <span class="text-amber-600 font-bold"> — ลาน: {{ selectedSiteName || 'กรุณาเลือกลาน' }}</span>
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
      <button type="button" (click)="showHelp = !showHelp"
        class="w-full sm:w-auto px-4 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 transition-all flex items-center justify-center gap-2 h-[46px] font-bold"
        [ngClass]="showHelp ? 'text-amber-600 border-amber-300' : ''">
        <span class="material-icons text-[20px]">help_outline</span>
        วิธีใช้งาน
      </button>
      <button type="button" (click)="onRefresh()" [disabled]="!selectedSiteId || isLoading()" title="โหลดใหม่"
        class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 transition-all flex items-center justify-center h-[46px] disabled:opacity-50">
        <span class="material-icons">refresh</span>
      </button>
      <button type="button" (click)="startAllocate()"
        [disabled]="!selectedSiteId || !canUpdate || isLoading() || !siteQuotas().length"
        class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg flex items-center justify-center gap-2 h-[46px] disabled:opacity-50 disabled:cursor-not-allowed">
        <span class="material-icons text-xl">card_giftcard</span>
        แจกสิทธิ์ให้ Client
      </button>
    </div>
  </div>

  <!-- ===== Scope banner ===== -->
  <div *ngIf="isAccessScoped"
    class="mb-4 flex items-start gap-3 rounded-2xl border border-sky-200/70 dark:border-sky-800/50 bg-sky-50/60 dark:bg-sky-900/20 px-4 py-3">
    <span class="material-icons text-sky-500 text-[20px]">groups</span>
    <p class="text-sm font-semibold text-sky-800 dark:text-sky-200">
      แสดงเฉพาะ Client ในกลุ่มสิทธิ์ของคุณ
      <span *ngIf="!canUpdate" class="block text-xs font-medium text-slate-500 dark:text-slate-400 mt-0.5">
        กลุ่มนี้ไม่มีสิทธิ์แจกโควต้า — ดูได้อย่างเดียว
      </span>
    </p>
  </div>

  <!-- ===== Help (collapsible) ===== -->
  <div *ngIf="showHelp"
    class="mb-6 animate-fade-in rounded-2xl border border-amber-200/70 dark:border-amber-800/50 bg-amber-50/50 dark:bg-amber-900/20 p-4 md:p-5">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
      <div class="flex gap-3">
        <span class="w-8 h-8 shrink-0 rounded-full bg-amber-400 text-white font-black flex items-center justify-center">1</span>
        <div>
          <p class="font-bold text-slate-800 dark:text-slate-100">ดูโควต้าลาน</p>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">Admin ตั้งจำนวนที่เมนูโควต้าจอดฟรี (ลาน) — หน้านี้แจกต่อเท่านั้น</p>
        </div>
      </div>
      <div class="flex gap-3">
        <span class="w-8 h-8 shrink-0 rounded-full bg-amber-400 text-white font-black flex items-center justify-center">2</span>
        <div>
          <p class="font-bold text-slate-800 dark:text-slate-100">แจกสิทธิ์ให้ Client</p>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">เลือกประเภทรถ → Client → จำนวน · หักจากที่ลานเหลือแจก</p>
        </div>
      </div>
      <div class="flex gap-3">
        <span class="w-8 h-8 shrink-0 rounded-full bg-amber-400 text-white font-black flex items-center justify-center">3</span>
        <div>
          <p class="font-bold text-slate-800 dark:text-slate-100">ดูแลสิทธิ์ที่แจกแล้ว</p>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">ปรับจำนวน · คืนส่วนที่ยังไม่ออกบัตร · ยกเลิก · ดูประวัติ</p>
        </div>
      </div>
    </div>
    <p class="mt-4 text-xs text-slate-500 dark:text-slate-400 flex items-center gap-1.5">
      <span class="material-icons text-[16px] text-amber-500">info</span>
      บัตรหมดอายุเองไม่คืนโควต้า · ต้องลบบัตรจึงจะคืน
    </p>
  </div>

  <!-- ===== No site ===== -->
  <div *ngIf="!selectedSiteId"
    class="bg-white dark:bg-slate-800 rounded-3xl shadow border border-slate-100 dark:border-slate-700 p-12 text-center">
    <span class="material-icons text-5xl text-amber-400 mb-2">local_parking</span>
    <p class="font-bold text-slate-700 dark:text-slate-200">เลือกลานจากแถบด้านข้างก่อน</p>
  </div>

  <ng-container *ngIf="selectedSiteId">

    <!-- ===== KPI ===== -->
    <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-100 dark:border-slate-700 p-5 flex items-center gap-4">
        <span class="w-11 h-11 rounded-xl bg-slate-100 dark:bg-slate-700 text-slate-500 flex items-center justify-center">
          <span class="material-icons">inventory_2</span>
        </span>
        <div>
          <p class="text-xs font-bold text-slate-400 uppercase">โควต้าลานทั้งหมด</p>
          <p class="text-2xl font-black text-slate-800 dark:text-slate-100">{{ totalApproved | number }}</p>
        </div>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-100 dark:border-slate-700 p-5 flex items-center gap-4">
        <span class="w-11 h-11 rounded-xl bg-amber-50 dark:bg-amber-900/30 text-amber-500 flex items-center justify-center">
          <span class="material-icons">call_split</span>
        </span>
        <div>
          <p class="text-xs font-bold text-slate-400 uppercase">แจก Client แล้ว</p>
          <p class="text-2xl font-black text-slate-800 dark:text-slate-100">{{ totalAllocated | number }}</p>
        </div>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-100 dark:border-slate-700 p-5 flex items-center gap-4">
        <span class="w-11 h-11 rounded-xl bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 flex items-center justify-center">
          <span class="material-icons">savings</span>
        </span>
        <div>
          <p class="text-xs font-bold text-slate-400 uppercase">ลานเหลือแจกได้</p>
          <p class="text-2xl font-black text-emerald-600">{{ totalPoolRemaining | number }}</p>
        </div>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-100 dark:border-slate-700 p-5 flex items-center gap-4">
        <span class="w-11 h-11 rounded-xl bg-sky-50 dark:bg-sky-900/30 text-sky-600 flex items-center justify-center">
          <span class="material-icons">confirmation_number</span>
        </span>
        <div>
          <p class="text-xs font-bold text-slate-400 uppercase">สิทธิ์ Client คงเหลือ</p>
          <p class="text-2xl font-black text-sky-600">{{ totalClientRemaining | number }}</p>
        </div>
      </div>
    </div>

    <!-- ===== Site pool by vehicle type ===== -->
    <div class="bg-white dark:bg-slate-800 rounded-3xl shadow border border-slate-100 dark:border-slate-700 overflow-hidden mb-6">
      <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col md:flex-row md:items-center justify-between gap-3">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">local_parking</span>
          โควต้าของลาน (แยกตามประเภทรถ)
        </h3>
        <a routerLink="/system-settings/site-free-quota"
          class="text-xs font-bold text-amber-600 hover:text-amber-700 inline-flex items-center gap-1">
          ตั้งโควต้าลาน (Admin)
          <span class="material-icons text-[14px]">open_in_new</span>
        </a>
      </div>

      <div *ngIf="siteQuotas().length === 0" class="p-10 text-center">
        <span class="material-icons text-4xl text-slate-300 mb-2">inventory_2</span>
        <p class="font-bold text-slate-700 dark:text-slate-200">ยังไม่มีโควต้าลาน</p>
        <p class="text-sm text-slate-400 mt-1">ให้ Admin ตั้งจำนวนที่เมนูโควต้าจอดฟรี (ลาน) ก่อน</p>
      </div>

      <div *ngIf="siteQuotas().length" class="p-6 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        <div *ngFor="let row of siteQuotas(); trackBy: trackSite"
          class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-900/40 p-5">
          <div class="flex items-start justify-between gap-3">
            <div class="flex items-center gap-3 min-w-0">
              <span class="w-10 h-10 rounded-xl bg-white dark:bg-slate-800 shadow-sm text-amber-500 flex items-center justify-center shrink-0">
                <span class="material-icons">{{ vehicleIcon(row.vehicleTypeName) }}</span>
              </span>
              <div class="min-w-0">
                <p class="font-extrabold text-slate-800 dark:text-slate-100 truncate">
                  {{ row.vehicleTypeName || ('ประเภท #' + row.vehicleTypeId) }}
                </p>
                <p class="text-xs text-slate-400 truncate" [title]="row.subscriptionName">{{ row.subscriptionName || '—' }}</p>
              </div>
            </div>
            <div class="text-right shrink-0">
              <p class="text-2xl font-black text-emerald-600 leading-none">{{ poolRemaining(row) | number }}</p>
              <p class="text-[11px] font-bold text-slate-400 mt-1">เหลือแจกได้</p>
            </div>
          </div>

          <div class="mt-4">
            <div class="flex justify-between text-[11px] font-bold text-slate-400 mb-1.5">
              <span>แจกแล้ว {{ row.quotaAllocatedToClients | number }} / {{ row.quotaApproved | number }}</span>
              <span>{{ sitePoolPercent(row) }}%</span>
            </div>
            <div class="h-2 rounded-full bg-slate-200 dark:bg-slate-700 overflow-hidden">
              <div class="h-full rounded-full transition-all"
                [ngClass]="sitePoolPercent(row) >= 100 ? 'bg-rose-500' : sitePoolPercent(row) >= 80 ? 'bg-amber-400' : 'bg-emerald-500'"
                [style.width.%]="sitePoolPercent(row)"></div>
            </div>
            <p class="text-[11px] text-slate-400 mt-2">
              ออกบัตรตรงจากลาน (ไม่ผ่าน Client) {{ row.quotaUsed | number }} ใบ
            </p>
          </div>

          <button *ngIf="canUpdate" type="button" (click)="startAllocate(row.vehicleTypeId)"
            [disabled]="poolRemaining(row) <= 0"
            class="mt-4 w-full h-10 rounded-xl border border-amber-200 dark:border-amber-800/60 bg-white dark:bg-slate-800 text-amber-700 dark:text-amber-400 font-bold text-sm hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-colors disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-1.5">
            <span class="material-icons text-[18px]">card_giftcard</span>
            แจกประเภทนี้
          </button>
        </div>
      </div>
    </div>

    <!-- ===== Client allocations table ===== -->
    <div class="bg-white dark:bg-slate-800 rounded-3xl shadow border border-slate-100 dark:border-slate-700 overflow-hidden">

      <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col xl:flex-row xl:items-center justify-between gap-4">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2 shrink-0">
          <span class="material-icons text-amber-500">storefront</span>
          สิทธิ์ที่แจกให้ Client แล้ว
          <span class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
            {{ clientQuotas().length }} รายการ
          </span>
        </h3>

        <div class="flex flex-col md:flex-row gap-3 w-full xl:flex-1 xl:min-w-0 xl:justify-end">
          <!-- Status segmented -->
          <div class="flex items-center p-1 bg-slate-50 dark:bg-slate-900 border border-slate-50 dark:border-slate-800 rounded-xl h-[46px] shadow-sm overflow-x-auto">
            <ng-container *ngFor="let tab of statusTabs; let last = last">
              <button type="button" (click)="setStatusFilter(tab.value)"
                class="px-3 h-full rounded-lg text-sm font-bold transition-all duration-200 flex items-center gap-1.5 whitespace-nowrap"
                [ngClass]="statusFilter() === tab.value
                  ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-sm'
                  : 'text-slate-400 dark:text-slate-500 hover:text-amber-600'">
                {{ tab.label }}
                <span class="text-[11px] px-1.5 py-0.5 rounded-md"
                  [ngClass]="statusFilter() === tab.value ? 'bg-amber-50 dark:bg-amber-900/30' : 'bg-slate-100 dark:bg-slate-800'">
                  {{ statusCounts()[tab.value] }}
                </span>
              </button>
              <span *ngIf="!last" class="w-[1px] h-4 bg-slate-200 dark:bg-slate-700 mx-1 shrink-0"></span>
            </ng-container>
          </div>

          <!-- Search -->
          <div
            class="flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all w-full md:flex-1 md:max-w-[360px] h-[46px] overflow-hidden">
            <span class="material-icons ml-3 text-xl text-slate-400 dark:text-slate-500">search</span>
            <input type="text" [ngModel]="clientListSearch()" (ngModelChange)="onSearchChange($event)"
              placeholder="ค้นหา Client / ประเภทรถ..."
              class="min-w-0 flex-1 h-full px-3 bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-600">
            <button *ngIf="clientListSearch()" type="button" (click)="onSearchChange('')"
              class="mr-2 text-slate-400 hover:text-rose-500">
              <span class="material-icons text-[18px]">close</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Vehicle type category chips -->
      <div *ngIf="vehicleTabs.length > 1"
        class="px-6 py-3 border-b border-slate-100 dark:border-slate-700 flex flex-wrap items-center gap-2">
        <span class="text-xs font-bold text-slate-400 uppercase tracking-wider mr-1">ประเภทรถ</span>
        <button type="button" (click)="setVehicleFilter(0)"
          class="px-3 py-1.5 rounded-full text-xs font-bold border transition-colors"
          [ngClass]="vehicleFilter() === 0
            ? 'bg-amber-400 border-amber-400 text-white shadow-[0_4px_12px_rgba(251,191,36,0.35)]'
            : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-500 hover:border-amber-300 hover:text-amber-600'">
          ทั้งหมด
        </button>
        <button *ngFor="let vt of vehicleTabs" type="button" (click)="setVehicleFilter(vt.id)"
          class="px-3 py-1.5 rounded-full text-xs font-bold border transition-colors flex items-center gap-1"
          [ngClass]="vehicleFilter() === vt.id
            ? 'bg-amber-400 border-amber-400 text-white shadow-[0_4px_12px_rgba(251,191,36,0.35)]'
            : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-500 hover:border-amber-300 hover:text-amber-600'">
          <span class="material-icons text-[16px]">{{ vehicleIcon(vt.name) }}</span>
          {{ vt.name }}
        </button>
      </div>

      <div class="overflow-x-auto min-h-[280px]">
        <table class="w-full text-left text-sm min-w-[920px]">
          <thead class="bg-slate-50 dark:bg-slate-800/50 text-xs uppercase text-slate-400">
            <tr>
              <th class="px-6 py-4">
                <button type="button" (click)="toggleSort('client')" class="inline-flex items-center gap-1 uppercase font-bold hover:text-amber-600">
                  Client / ผู้เช่า <span class="material-icons text-[16px]">{{ sortIcon('client') }}</span>
                </button>
              </th>
              <th class="px-6 py-4">
                <button type="button" (click)="toggleSort('vehicle')" class="inline-flex items-center gap-1 uppercase font-bold hover:text-amber-600">
                  ประเภทรถ <span class="material-icons text-[16px]">{{ sortIcon('vehicle') }}</span>
                </button>
              </th>
              <th class="px-6 py-4 min-w-[200px]">
                <button type="button" (click)="toggleSort('usage')" class="inline-flex items-center gap-1 uppercase font-bold hover:text-amber-600">
                  การใช้สิทธิ์ <span class="material-icons text-[16px]">{{ sortIcon('usage') }}</span>
                </button>
              </th>
              <th class="px-6 py-4 text-right">
                <button type="button" (click)="toggleSort('approved')" class="inline-flex items-center gap-1 uppercase font-bold hover:text-amber-600">
                  ได้รับ <span class="material-icons text-[16px]">{{ sortIcon('approved') }}</span>
                </button>
              </th>
              <th class="px-6 py-4 text-right">
                <button type="button" (click)="toggleSort('remaining')" class="inline-flex items-center gap-1 uppercase font-bold hover:text-amber-600">
                  เหลือใช้ <span class="material-icons text-[16px]">{{ sortIcon('remaining') }}</span>
                </button>
              </th>
              <th class="px-6 py-4">ผู้ดูแล</th>
              <th class="px-6 py-4 text-center">จัดการ</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cq of pagedClientQuotas(); trackBy: trackClient"
              class="border-t border-slate-100 dark:border-slate-800 hover:bg-slate-50/50 dark:hover:bg-slate-800/30">
              <td class="px-6 py-4">
                <p class="font-semibold text-slate-800 dark:text-slate-100 truncate max-w-[240px]" [title]="cq.clientName">
                  {{ cq.clientName || ('#' + cq.clientId) }}
                </p>
                <span class="inline-block mt-1 text-[11px] font-bold px-2 py-0.5 rounded-md" [ngClass]="statusBadgeClass(cq)">
                  {{ statusLabel(cq) }}
                </span>
              </td>
              <td class="px-6 py-4">
                <span class="inline-flex items-center gap-1.5">
                  <span class="material-icons text-[18px] text-slate-400">{{ vehicleIcon(cq.vehicleTypeName) }}</span>
                  {{ cq.vehicleTypeName || cq.vehicleTypeId }}
                </span>
              </td>
              <td class="px-6 py-4">
                <div class="flex items-center gap-3">
                  <div class="flex-1 h-2 rounded-full bg-slate-100 dark:bg-slate-700 overflow-hidden">
                    <div class="h-full rounded-full transition-all" [ngClass]="usageBarClass(cq)" [style.width.%]="usagePercent(cq)"></div>
                  </div>
                  <span class="text-xs font-bold text-slate-500 whitespace-nowrap">
                    {{ cq.quotaUsed | number }} / {{ cq.quotaApproved | number }}
                  </span>
                </div>
              </td>
              <td class="px-6 py-4 text-right font-bold text-slate-800 dark:text-slate-100">{{ cq.quotaApproved | number }}</td>
              <td class="px-6 py-4 text-right font-bold"
                [ngClass]="cq.quotaRemaining > 0 ? 'text-emerald-600' : 'text-rose-500'">
                {{ cq.quotaRemaining | number }}
              </td>
              <td class="px-6 py-4">
                <span class="text-xs font-bold px-2 py-1 rounded-lg"
                  [ngClass]="cq.managedBy === 'client_self'
                    ? 'bg-sky-50 text-sky-700 dark:bg-sky-900/20 dark:text-sky-300'
                    : 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300'">
                  {{ managedByLabel(cq.managedBy) }}
                </span>
              </td>
              <td class="px-6 py-4">
                <div class="flex items-center justify-center gap-1">
                  <button *ngIf="canUpdate" type="button" (click)="openEdit(cq)" title="ปรับจำนวน"
                    class="p-2 rounded-lg hover:bg-amber-50 dark:hover:bg-amber-900/20 text-amber-600">
                    <span class="material-icons text-[18px]">edit</span>
                  </button>
                  <button *ngIf="canUpdate" type="button" (click)="reclaimUnusedClientQuota(cq)"
                    [disabled]="cq.quotaRemaining <= 0" title="คืนสิทธิ์ที่ยังไม่ใช้กลับลาน"
                    class="p-2 rounded-lg hover:bg-sky-50 dark:hover:bg-sky-900/20 text-sky-600 disabled:opacity-30 disabled:cursor-not-allowed">
                    <span class="material-icons text-[18px]">undo</span>
                  </button>
                  <button *ngIf="canUpdate" type="button" (click)="cancelClientQuota(cq)" title="ยกเลิกสิทธิ์"
                    class="p-2 rounded-lg hover:bg-rose-50 dark:hover:bg-rose-900/20 text-rose-500">
                    <span class="material-icons text-[18px]">delete_outline</span>
                  </button>
                  <button type="button" (click)="openHistory(cq, $event)" title="ประวัติ"
                    class="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500">
                    <span class="material-icons text-[18px]">history</span>
                  </button>
                </div>
              </td>
            </tr>

            <tr *ngIf="!isLoading() && filteredClientQuotas().length === 0">
              <td colspan="7" class="px-6 py-16 text-center text-slate-400">
                <ng-container *ngIf="clientQuotas().length === 0; else noMatch">
                  <span class="material-icons text-4xl text-slate-300 mb-2">storefront</span>
                  <p class="font-bold text-slate-600 dark:text-slate-300 mb-1">ยังไม่มีการแจกสิทธิ์ให้ Client</p>
                  <p class="text-sm mb-4">กด “แจกสิทธิ์ให้ Client” เมื่อมีโควต้าลานแล้ว</p>
                  <button *ngIf="canUpdate" type="button" (click)="startAllocate()" [disabled]="!siteQuotas().length"
                    class="px-5 h-10 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold disabled:opacity-50 inline-flex items-center gap-2">
                    <span class="material-icons text-[18px]">card_giftcard</span>
                    เริ่มแจกสิทธิ์
                  </button>
                </ng-container>
                <ng-template #noMatch>ไม่พบรายการตามเงื่อนไขที่เลือก</ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Standard Pagination Footer -->
      <div *ngIf="filteredClientQuotas().length > 0"
        class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div class="flex items-center gap-3">
          <span class="text-xs font-semibold text-slate-500">
            แสดง {{ startItemIndex }} - {{ endItemIndex }} จาก {{ filteredClientQuotas().length }} รายการ
          </span>
          <div class="relative">
            <button type="button" (click)="togglePageSizeDropdown()" (blur)="closePageSizeDropdown()"
              class="flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700 rounded-xl text-xs font-bold text-slate-700 dark:text-slate-200 hover:bg-slate-50 focus:outline-none focus:ring-1 focus:ring-amber-400 cursor-pointer transition-all shadow-sm">
              <span>{{ pageSize() }} / หน้า</span>
              <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
                [class.rotate-180]="isPageSizeDropdownOpen">expand_more</span>
            </button>
            <div *ngIf="isPageSizeDropdownOpen" (mousedown)="$event.preventDefault()"
              class="absolute bottom-full left-0 mb-1.5 z-50 min-w-[5rem] bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-xl shadow-lg py-1 animate-fade-in text-center">
              <button *ngFor="let opt of pageSizeOptions" type="button" (click)="selectPageSize(opt)"
                class="w-full text-center px-3 py-2 text-xs font-bold text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-600 block transition-colors cursor-pointer">
                {{ opt }} / หน้า
              </button>
            </div>
          </div>
        </div>

        <div class="flex items-center gap-1">
          <button type="button" (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
            class="w-8 h-8 rounded-lg border border-slate-200/60 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-500 disabled:opacity-40 hover:bg-slate-50 transition-colors flex items-center justify-center cursor-pointer">
            <span class="material-icons text-sm">chevron_left</span>
          </button>
          <ng-container *ngFor="let page of pagesArray">
            <button *ngIf="page === currentPage()" type="button"
              class="w-8 h-8 rounded-lg bg-amber-400 text-slate-900 font-bold shadow-[0_4px_12px_rgba(251,191,36,0.35)] flex items-center justify-center text-xs">
              {{ page }}
            </button>
            <button *ngIf="page !== currentPage()" type="button" (click)="setPage(page)"
              class="w-8 h-8 rounded-lg text-slate-700 dark:text-slate-300 font-bold hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 transition-colors flex items-center justify-center text-xs cursor-pointer">
              {{ page }}
            </button>
          </ng-container>
          <button type="button" (click)="setPage(currentPage() + 1)" [disabled]="currentPage() === totalPages()"
            class="w-8 h-8 rounded-lg border border-slate-200/60 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-500 disabled:opacity-40 hover:bg-slate-50 transition-colors flex items-center justify-center cursor-pointer">
            <span class="material-icons text-sm">chevron_right</span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- ===== Allocate modal ===== -->
<div *ngIf="showAllocateModal"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="cancelAllocate()">
  <div (click)="$event.stopPropagation()"
    class="w-full max-w-2xl max-h-[92vh] flex flex-col bg-white dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 animate-fade-in-up">

    <div class="px-6 md:px-8 pt-6 pb-4 flex items-start justify-between gap-3 border-b border-slate-100 dark:border-slate-800">
      <div class="flex items-center gap-3">
        <span class="w-11 h-11 rounded-2xl bg-amber-50 dark:bg-amber-900/30 text-amber-500 flex items-center justify-center">
          <span class="material-icons">card_giftcard</span>
        </span>
        <div>
          <h2 class="text-xl font-extrabold text-slate-800 dark:text-slate-100">แจกสิทธิ์ให้ Client</h2>
          <p class="text-xs text-slate-400 mt-0.5">หักจากโควต้าลาน {{ selectedSiteName }}</p>
        </div>
      </div>
      <button type="button" (click)="cancelAllocate()" class="p-2 rounded-xl text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="px-6 md:px-8 py-6 space-y-6 overflow-y-auto custom-scrollbar">
      <!-- 1. Vehicle type -->
      <div>
        <p class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">1 · ประเภทรถ</p>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <button *ngFor="let row of siteQuotas(); trackBy: trackSite" type="button"
            (click)="selectAllocateVehicle(row.vehicleTypeId)"
            [disabled]="poolRemaining(row) <= 0"
            class="text-left rounded-2xl border-2 p-4 transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-3"
            [ngClass]="allocateVehicleTypeId === row.vehicleTypeId
              ? 'border-amber-400 bg-amber-50/60 dark:bg-amber-900/20'
              : 'border-slate-100 dark:border-slate-700 hover:border-amber-200'">
            <span class="material-icons text-2xl" [ngClass]="allocateVehicleTypeId === row.vehicleTypeId ? 'text-amber-500' : 'text-slate-400'">
              {{ vehicleIcon(row.vehicleTypeName) }}
            </span>
            <span class="flex-1 min-w-0">
              <span class="block font-bold text-slate-800 dark:text-slate-100 truncate">{{ row.vehicleTypeName || ('ประเภท #' + row.vehicleTypeId) }}</span>
              <span class="block text-xs text-slate-400">เหลือแจกได้ <b class="text-emerald-600">{{ poolRemaining(row) | number }}</b> / {{ row.quotaApproved | number }}</span>
            </span>
            <span *ngIf="allocateVehicleTypeId === row.vehicleTypeId" class="material-icons text-amber-500">check_circle</span>
          </button>
        </div>
      </div>

      <!-- 2. Client -->
      <div class="relative">
        <p class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">2 · Client / ผู้เช่า</p>
        <div class="relative">
          <span class="material-icons absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-[18px] pointer-events-none">
            {{ allocateClientId && !isAllocateClientOpen ? 'store' : 'search' }}
          </span>
          <input type="text"
            [ngModel]="isAllocateClientOpen ? allocateClientSearch : allocateClientName"
            (ngModelChange)="allocateClientSearch = $event"
            (focus)="openAllocateClientList()" (blur)="closeAllocateClientList()"
            [readonly]="!canUpdate || isAllocating()"
            [placeholder]="allocateClientName || 'ค้นหาและเลือก Client...'"
            class="w-full h-[46px] rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-100/30 dark:bg-slate-800 pl-10 pr-16 text-sm focus:outline-none focus:ring-2 focus:ring-amber-200"
            [ngClass]="allocateClientId && !isAllocateClientOpen ? 'font-bold text-slate-800 dark:text-slate-100' : ''" />
          <button *ngIf="allocateClientId && canUpdate && !isAllocating()" type="button"
            (mousedown)="$event.preventDefault(); clearAllocateClient()"
            class="absolute right-9 top-1/2 -translate-y-1/2 text-slate-400 hover:text-rose-500">
            <span class="material-icons text-[18px]">close</span>
          </button>
          <span class="material-icons absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 text-[18px] pointer-events-none transition-transform"
            [class.rotate-180]="isAllocateClientOpen">expand_more</span>
        </div>
        <div *ngIf="isAllocateClientOpen" (mousedown)="$event.preventDefault()"
          class="absolute z-30 left-0 right-0 mt-1 max-h-60 overflow-y-auto custom-scrollbar rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-xl py-1">
          <button *ngFor="let c of filteredAllocateClients" type="button"
            (mousedown)="$event.preventDefault(); selectAllocateClient(c)"
            class="w-full text-left px-4 py-2.5 text-sm font-medium flex items-center justify-between gap-2 transition-colors hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600"
            [ngClass]="c.id === allocateClientId ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400' : 'text-slate-700 dark:text-slate-200'">
            <span class="truncate">{{ c.name }}</span>
            <span *ngIf="c.id === allocateClientId" class="material-icons text-[18px] shrink-0">check</span>
          </button>
          <div *ngIf="filteredAllocateClients.length === 0" class="px-4 py-3 text-sm text-slate-400">ไม่พบ Client ที่ค้นหา</div>
        </div>
        <p *ngIf="allocateExistingRow as ex" class="text-[11px] text-sky-600 dark:text-sky-300 mt-1.5 flex items-center gap-1">
          <span class="material-icons text-[14px]">info</span>
          Client นี้มีสิทธิ์อยู่แล้ว {{ ex.quotaApproved | number }} (ใช้ {{ ex.quotaUsed | number }}) — จำนวนที่แจกจะบวกเพิ่ม
        </p>
      </div>

      <!-- 3. Quantity -->
      <div>
        <p class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">3 · จำนวนสิทธิ์ที่แจก</p>
        <div class="flex items-center gap-2">
          <button type="button" (click)="stepAllocate(-1)" [disabled]="!allocateVehicleTypeId || allocateAdditionalQuota <= 0 || isAllocating()"
            class="w-[46px] h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 hover:text-amber-600 hover:border-amber-300 disabled:opacity-40 flex items-center justify-center">
            <span class="material-icons">remove</span>
          </button>
          <input type="number" min="1" [max]="allocatePoolRemaining || null"
            [(ngModel)]="allocateAdditionalQuota" [disabled]="!allocateVehicleTypeId || !canUpdate || isAllocating()"
            class="w-32 h-[46px] text-center text-lg font-black rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-100/30 dark:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50" />
          <button type="button" (click)="stepAllocate(1)" [disabled]="!allocateVehicleTypeId || allocateAdditionalQuota >= allocatePoolRemaining || isAllocating()"
            class="w-[46px] h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 hover:text-amber-600 hover:border-amber-300 disabled:opacity-40 flex items-center justify-center">
            <span class="material-icons">add</span>
          </button>
          <button type="button" (click)="fillAllocateMax()" [disabled]="!allocateVehicleTypeId || allocatePoolRemaining <= 0 || isAllocating()"
            class="px-3 h-[46px] rounded-xl text-xs font-bold text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/20 hover:bg-amber-100 disabled:opacity-40">
            ทั้งหมด ({{ allocatePoolRemaining | number }})
          </button>
        </div>
        <p *ngIf="!allocateVehicleTypeId" class="text-[11px] text-slate-400 mt-1.5">เลือกประเภทรถก่อน</p>
        <p *ngIf="allocateAdditionalQuota > allocatePoolRemaining" class="text-[11px] text-rose-500 mt-1.5">
          เกินที่ลานเหลือแจก ({{ allocatePoolRemaining | number }})
        </p>
      </div>

      <!-- 4. Managed by -->
      <div>
        <p class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">4 · ผู้ดูแลโควต้านี้</p>
        <div class="flex items-center p-1 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl h-[46px] w-full sm:w-fit">
          <button *ngFor="let opt of managedByOptions" type="button" (click)="allocateManagedBy = opt.value"
            [disabled]="!canUpdate || isAllocating()"
            class="flex-1 sm:flex-none px-4 h-full rounded-lg text-sm font-bold transition-all"
            [ngClass]="allocateManagedBy === opt.value
              ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-sm'
              : 'text-slate-400 hover:text-amber-600'">
            {{ managedByLabel(opt.value) }}
          </button>
        </div>
      </div>

      <!-- Summary -->
      <div *ngIf="allocateSiteRow as site"
        class="rounded-2xl border border-emerald-200/70 dark:border-emerald-800/50 bg-emerald-50/50 dark:bg-emerald-900/20 p-4 grid grid-cols-3 gap-3 text-center">
        <div>
          <p class="text-[11px] font-bold text-slate-400 uppercase">ลานเหลือแจก</p>
          <p class="text-lg font-black text-slate-800 dark:text-slate-100">{{ poolRemaining(site) | number }}</p>
        </div>
        <div>
          <p class="text-[11px] font-bold text-slate-400 uppercase">แจกครั้งนี้</p>
          <p class="text-lg font-black text-amber-600">-{{ (allocateAdditionalQuota || 0) | number }}</p>
        </div>
        <div>
          <p class="text-[11px] font-bold text-slate-400 uppercase">คงเหลือหลังแจก</p>
          <p class="text-lg font-black text-emerald-600">{{ (poolRemaining(site) - (allocateAdditionalQuota || 0)) | number }}</p>
        </div>
      </div>
    </div>

    <div class="px-6 md:px-8 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-3">
      <button type="button" (click)="cancelAllocate()" [disabled]="isAllocating()"
        class="px-5 h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800">
        ยกเลิก
      </button>
      <button type="button" (click)="onAllocate()" [disabled]="!canSubmitAllocate"
        class="px-6 h-[46px] rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-[0_4px_12px_rgba(251,191,36,0.35)] disabled:opacity-50 disabled:shadow-none disabled:cursor-not-allowed inline-flex items-center gap-2">
        <span class="material-icons text-[18px]">check</span>
        {{ isAllocating() ? 'กำลังแจก...' : 'ยืนยันแจกสิทธิ์' }}
      </button>
    </div>
  </div>
</div>

<!-- ===== Edit modal ===== -->
<div *ngIf="showEditModal && selectedClientRow() as row"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="closeEdit()">
  <div (click)="$event.stopPropagation()"
    class="w-full max-w-lg max-h-[92vh] flex flex-col bg-white dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 animate-fade-in-up">

    <div class="px-6 md:px-8 pt-6 pb-4 flex items-start justify-between gap-3 border-b border-slate-100 dark:border-slate-800">
      <div class="flex items-center gap-3 min-w-0">
        <span class="w-11 h-11 shrink-0 rounded-2xl bg-amber-50 dark:bg-amber-900/30 text-amber-500 flex items-center justify-center">
          <span class="material-icons">tune</span>
        </span>
        <div class="min-w-0">
          <h2 class="text-xl font-extrabold text-slate-800 dark:text-slate-100 truncate">{{ row.clientName || ('#' + row.clientId) }}</h2>
          <p class="text-xs text-slate-400 mt-0.5 flex items-center gap-1">
            <span class="material-icons text-[14px]">{{ vehicleIcon(row.vehicleTypeName) }}</span>
            {{ row.vehicleTypeName }}
          </p>
        </div>
      </div>
      <button type="button" (click)="closeEdit()" class="p-2 rounded-xl text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="px-6 md:px-8 py-6 space-y-5 overflow-y-auto custom-scrollbar">
      <div class="grid grid-cols-3 gap-3 text-center">
        <div class="rounded-2xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 p-3">
          <p class="text-[11px] font-bold text-slate-400 uppercase">ได้รับ</p>
          <p class="text-lg font-black text-slate-800 dark:text-slate-100">{{ row.quotaApproved | number }}</p>
        </div>
        <div class="rounded-2xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 p-3">
          <p class="text-[11px] font-bold text-slate-400 uppercase">ออกบัตรแล้ว</p>
          <p class="text-lg font-black text-slate-800 dark:text-slate-100">{{ row.quotaUsed | number }}</p>
        </div>
        <div class="rounded-2xl bg-emerald-50/50 dark:bg-emerald-900/20 border border-emerald-200/70 dark:border-emerald-800/50 p-3">
          <p class="text-[11px] font-bold text-slate-400 uppercase">เหลือใช้</p>
          <p class="text-lg font-black text-emerald-600">{{ row.quotaRemaining | number }}</p>
        </div>
      </div>

      <div>
        <p class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">จำนวนสิทธิ์ทั้งหมด</p>
        <div class="flex items-center gap-2">
          <button type="button" (click)="stepEdit(-1)" [disabled]="editClientQuotaApproved <= row.quotaUsed || isUpdatingClient()"
            class="w-[46px] h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 hover:text-amber-600 hover:border-amber-300 disabled:opacity-40 flex items-center justify-center">
            <span class="material-icons">remove</span>
          </button>
          <input type="number" [min]="row.quotaUsed" [max]="editMaxApproved"
            [(ngModel)]="editClientQuotaApproved" [disabled]="!canUpdate || isUpdatingClient()"
            class="w-32 h-[46px] text-center text-lg font-black rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-100/30 dark:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-amber-200" />
          <button type="button" (click)="stepEdit(1)" [disabled]="editClientQuotaApproved >= editMaxApproved || isUpdatingClient()"
            class="w-[46px] h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 hover:text-amber-600 hover:border-amber-300 disabled:opacity-40 flex items-center justify-center">
            <span class="material-icons">add</span>
          </button>
        </div>
        <p class="text-[11px] text-slate-400 mt-1.5">
          ต่ำสุด {{ row.quotaUsed | number }} (ออกบัตรแล้ว) · สูงสุด {{ editMaxApproved | number }} (ตามที่ลานเหลือแจก)
        </p>
        <div *ngIf="editDelta !== 0"
          class="mt-3 rounded-xl px-3 py-2 text-sm font-bold flex items-center gap-2"
          [ngClass]="editDelta > 0
            ? 'bg-amber-50 text-amber-700 dark:bg-amber-900/20 dark:text-amber-300'
            : 'bg-sky-50 text-sky-700 dark:bg-sky-900/20 dark:text-sky-300'">
          <span class="material-icons text-[18px]">{{ editDelta > 0 ? 'trending_up' : 'trending_down' }}</span>
          {{ editDelta > 0 ? ('เพิ่ม ' + editDelta + ' — หักจากโควต้าลาน') : ('ลด ' + (-editDelta) + ' — คืนโควต้าลาน') }}
        </div>
      </div>

      <div>
        <p class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ผู้ดูแลโควต้านี้</p>
        <div class="flex items-center p-1 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl h-[46px] w-full sm:w-fit">
          <button *ngFor="let opt of managedByOptions" type="button" (click)="editClientManagedBy = opt.value"
            [disabled]="!canUpdate || isUpdatingClient()"
            class="flex-1 sm:flex-none px-4 h-full rounded-lg text-sm font-bold transition-all"
            [ngClass]="editClientManagedBy === opt.value
              ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-sm'
              : 'text-slate-400 hover:text-amber-600'">
            {{ managedByLabel(opt.value) }}
          </button>
        </div>
      </div>

      <div class="flex flex-wrap gap-2 pt-1">
        <button type="button" (click)="reclaimUnusedClientQuota(row)" [disabled]="row.quotaRemaining <= 0 || isUpdatingClient()"
          class="px-3 h-9 rounded-xl text-xs font-bold text-sky-700 dark:text-sky-300 bg-sky-50 dark:bg-sky-900/20 hover:bg-sky-100 disabled:opacity-40 inline-flex items-center gap-1">
          <span class="material-icons text-[16px]">undo</span>
          คืนที่เหลือ ({{ row.quotaRemaining | number }})
        </button>
        <button type="button" (click)="cancelClientQuota(row)" [disabled]="isUpdatingClient()"
          class="px-3 h-9 rounded-xl text-xs font-bold text-rose-600 dark:text-rose-300 bg-rose-50 dark:bg-rose-900/20 hover:bg-rose-100 disabled:opacity-40 inline-flex items-center gap-1">
          <span class="material-icons text-[16px]">delete_outline</span>
          ยกเลิกสิทธิ์
        </button>
        <button type="button" (click)="openHistory(row)"
          class="px-3 h-9 rounded-xl text-xs font-bold text-slate-600 dark:text-slate-300 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 inline-flex items-center gap-1">
          <span class="material-icons text-[16px]">history</span>
          ประวัติ
        </button>
      </div>
    </div>

    <div class="px-6 md:px-8 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-3">
      <button type="button" (click)="closeEdit()" [disabled]="isUpdatingClient()"
        class="px-5 h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800">
        ปิด
      </button>
      <button type="button" (click)="onUpdateClientQuota()"
        [disabled]="!canUpdate || isUpdatingClient() || (editDelta === 0 && editClientManagedBy === row.managedBy)"
        class="px-6 h-[46px] rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-[0_4px_12px_rgba(251,191,36,0.35)] disabled:opacity-50 disabled:shadow-none disabled:cursor-not-allowed inline-flex items-center gap-2">
        <span class="material-icons text-[18px]">save</span>
        {{ isUpdatingClient() ? 'กำลังบันทึก...' : 'บันทึก' }}
      </button>
    </div>
  </div>
</div>

<app-modal-admin-activity-history *ngIf="showActivityHistory"
  [entityType]="activityEntityTypes.ClientFreeQuota"
  [entityId]="historyEntityId"
  title="ประวัติสิทธิ์โควต้า Client"
  [subtitle]="selectedClientRow()?.clientName || ''"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>

<app-pss-confirm-modal *ngIf="showConfirm"
  [title]="confirmTitle"
  [message]="confirmMessage"
  [highlight]="confirmHighlight"
  [messageSuffix]="confirmMessageSuffix"
  confirmLabel="ใช่"
  cancelLabel="ไม่"
  [variant]="confirmVariant"
  [icon]="confirmIcon"
  [loading]="confirmLoading"
  [showIrreversibleNote]="confirmVariant === 'danger'"
  (confirm)="onConfirmYes()"
  (cancel)="onConfirmNo()">
</app-pss-confirm-modal>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>
